import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const usePlanSeriesCommunitiesDetailViewModel = () => {
  const [seriesDetail, setSeriesDetail] = useState({});
  const [accountDetail, setAccountDetail] = useState({});
  const [community, setCommunity] = useState({});

  const stateManager = useComponentState();
  const GET_SERIES_DETAIL_UUID = createUUID();
  const GET_ACCOUNT_DETAIL_UUID = createUUID();
  const GET_COMMUNITY_DETAILS_UUID = createUUID();

  const getSeriesDetail = (id) => {
    stateManager.abort(GET_SERIES_DETAIL_UUID);
    stateManager.run(async () => {
      const response = await homeService.series.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setSeriesDetail(response.data);
      }
    }, GET_SERIES_DETAIL_UUID);
  };

  const getAccountDetail = (id) => {
    stateManager.abort(GET_ACCOUNT_DETAIL_UUID);
    stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetail(response.data);
      }
    }, GET_ACCOUNT_DETAIL_UUID);
  };

  const getCommunityDetails = (id) => {
    stateManager.abort(GET_COMMUNITY_DETAILS_UUID);
    stateManager.run(async () => {
      const response = await homeService.communities.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setCommunity(response.data);
      }
    }, GET_COMMUNITY_DETAILS_UUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    seriesDetail,
    accountDetail,
    getSeriesDetail,
    getAccountDetail,
    community,
    getCommunityDetails,
  };
};
